import React from 'react'
import { AIGenerationMode } from '@marketing-milk/interfaces'

type Props = {
  mode: AIGenerationMode
  onChange: (mode: AIGenerationMode) => void
}

const MODES: { value: AIGenerationMode; label: string; description: string }[] = [
  {
    value: 'text',
    label: 'Text Only',
    description: 'Rewrite headline & body copy, keep the original image',
  },
  {
    value: 'image',
    label: 'Image Only',
    description: 'Restyle or regenerate the image, keep original copy',
  },
  {
    value: 'both',
    label: 'Text + Image',
    description: 'Regenerate both the image and the ad copy',
  },
]

export function GenerationControls({ mode, onChange }: Props) {
  return (
    <div className="flex gap-3">
      {MODES.map(option => (
        <button
          key={option.value}
          type="button"
          onClick={() => onChange(option.value)}
          className={`flex-1 rounded-xl border-2 px-4 py-3 text-left transition-all ${
            mode === option.value
              ? 'border-purple-600 bg-purple-50 text-purple-900'
              : 'border-gray-200 bg-white text-gray-700 hover:border-purple-300'
          }`}
        >
          <div className="font-semibold text-sm">{option.label}</div>
          <div className="text-xs text-gray-500 mt-0.5">{option.description}</div>
        </button>
      ))}
    </div>
  )
}
